
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWifi2OffGoogle as ObiWifi2OffGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wifi2-off-google.js';
 
 
 

 
 export const ObiWifi2OffGoogle = createComponent({
   react: React,
   tagName: 'obi-wifi2-off-google',
   elementClass: ObiWifi2OffGoogleElement,
   events: {
     
   }
  });
 
 